export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  summary: string;
  paragraphs: string[];
}

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: 'pos-close',
    title: 'Why every shift should close POS',
    date: '9 August 2026',
    summary: 'Opening float, expected cash, and a counted close are how you know the drawer matches the books.',
    paragraphs: [
      'A sale at the counter is only half the cash story. The other half is whether the drawer still matches what the register expected when the shift ends.',
      'cevop POS requires an opening float before selling, then tracks cash sales against that float. Card and transfer still post to revenue; they do not inflate expected drawer cash.',
      'At close, the cashier counts physical cash. Expected versus counted becomes a short or over on account 3200 so the cash account matches what was actually in the drawer.',
      'If a session is left open, that cashier cannot open a second one. Close first, then start the next shift.',
    ],
  },
  {
    slug: 'one-ledger',
    title: 'Two apps, one ledger',
    date: '9 August 2026',
    summary: 'POS is for the counter. Business is for stock, money, and reports. They share the same books.',
    paragraphs: [
      'cevop is not a cash register bolted onto a spreadsheet. A completed sale updates stock, cash position, and the journal in one posting.',
      'Cashiers stay on POS. Owners, managers, and accountants use the Business app. Roles are enforced on the server, not only in the menu.',
      'Reports — P&L, balance sheet, ledger, exports — read the same journals POS already wrote. You do not reconstruct the month from WhatsApp and a cash book.',
    ],
  },
  {
    slug: 'tax-at-the-pos',
    title: 'Exclusive vs inclusive tax at the register',
    date: '9 August 2026',
    summary: 'Shelf prices and cart totals must match how VAT posts. Set this before heavy trading.',
    paragraphs: [
      'Organisation tax settings flow to POS. Exclusive mode adds tax on the cart. Inclusive mode keeps one total for the cashier while the server still splits net and VAT.',
      'When tax is off, there is no tax line on the cart or journal until you enable it.',
      'Enable VAT in Settings before a busy period so cashiers and the ledger stay aligned. The full walkthrough is in Help.',
    ],
  },
];

export function getBlogPost(slug: string) {
  return BLOG_POSTS.find((post) => post.slug === slug);
}
